import { cn } from "@/lib/utils"
import { IconLoader6Fill18 } from "nucleo-ui-fill-18"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <IconLoader6Fill18
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
